// APP 相关
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const SHOW_SIDEBAR = "SHOW_SIDEBAR";
export const ADD_VISITED_VIEWS = "ADD_VISITED_VIEWS";
export const DEL_VISITED_VIEWS = "DEL_VISITED_VIEWS";

// user（用户）相关
export const RECEIVE_ADMIN_ID = "RECEIVE_ADMIN_ID"; // 用户ID
export const RECEIVE_ADMIN_TOKEN = "RECEIVE_ADMIN_TOKEN"; // token
export const RECEIVE_ADMIN_NAME = "RECEIVE_ADMIN_NAME"; // 昵称
export const RECEIVE_ADMIN_AVATAR = "RECEIVE_ADMIN_AVATAR"; // 头像
export const RECEIVE_ADMIN_AUTH_RULES = "RECEIVE_ADMIN_AUTH_RULES"; // 权限列表
export const RECEIVE_ROUTERS = "RECEIVE_ROUTERS"; // 初始化路由表
